import React from "react";
import './GlobalBackground.css';

interface Props {
  children: any;
}

const GlobalBackground: React.FC<Props> = ({ children }) => {
  return (
    <div className="hero-container">
      {/* Hero Content */}
      <div className="hero-content">{children}</div>
    </div>
  );
};

export default GlobalBackground;
